import { Flex, Text, Box, Input, Textarea } from "@chakra-ui/react";
import { InserirImagens } from "./InserirImagens";

export const InputsTroca = ({
  setFoto1,
  setFoto2,
  setFoto3,
  foto1,
  foto2,
  foto3,
  register,
  error,
}) => {
  console.log(error);

  return (
    <>
      <Flex align="start" gap={2}>
        <Flex align="center" flexDir="column">
          <Text bg="#378BBF" paddingBlock={2} paddingInline={4} color="white">
            PEÇAS COM DEFEITO
          </Text>
          <Input
            textAlign="center"
            placeholder="150"
            paddingBlock={2}
            type="number"
            size="xs"
            height="100%"
            mt={2}
            style={{ width: "100px" }}
            {...register("quantidade")}
            borderColor={error.quantidade ? "red" : "gray.300"}
          />
          {error.quantidade && (
            <Text color="red" fontSize="0.8rem">
              {error.quantidade.message}
            </Text>
          )}
        </Flex>
        <Flex align="center" flexDir="column" flex={1}>
          <Flex flexDir="column" w="full">
            <Text
              bg="#378BBF"
              paddingBlock={2}
              paddingInline={4}
              color="white"
              w={"100%"}
              textAlign="center"
            >
              OBSERVAÇÃO DO DEFEITO
            </Text>
            <Textarea
              textAlign="start"
              placeholder="Ex:. canetas apresentaram carga seca"
              size="xs"
              mt={2}
              {...register("descricao")}
              borderColor={error.descricao ? "red" : "gray.300"}
            />
            {error.descricao && (
              <Text color="red" fontSize="0.8rem">
                {error.descricao.message}
              </Text>
            )}
          </Flex>
          <InserirImagens
            setFoto1={setFoto1}
            setFoto2={setFoto2}
            setFoto3={setFoto3}
            foto1={foto1}
            foto2={foto2}
            foto3={foto3}
          />
        </Flex>
      </Flex>
    </>
  );
};
